import {React, useState, useEffect} from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { getDatabase, ref, child, get } from "firebase/database";


let sortedArray = [];
let oldArray = [];
export const SearchBar = (props) => {
    useEffect(() => {
        const dbRef = ref(getDatabase());
        get(child(dbRef, props.category)).then((snapshot) => {
            const Snapshot = snapshot.val();
            const SnapshotKeys = Object.keys(Snapshot);
            const SnapshotArray = SnapshotKeys.map((key) => {
                const singlePostCopy = {...Snapshot[key]};
                singlePostCopy.key = key;
                return singlePostCopy;
        });
    oldArray = SnapshotArray;
    });
}, []);

    const [queryText, setQueryText] = useState('');

    const handleChange = (event) => {
        setQueryText(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const query = encodeURIComponent(queryText);
        searchBarSort(oldArray, query);
    };

    //Function which reverts page to default if a blank string is searched.
    //Will update the page based off the user text input.
    function searchBarSort(array, searchInput){

        if (searchInput === "") {

            props.setArray(oldArray);

        } else {
            for (let i = 0; i< array.length; i++) {
                if (array[i].postTitle.toUpperCase() === searchInput.toUpperCase() || array[i].postTitle.toUpperCase().includes(searchInput.toUpperCase())) {
                    sortedArray.push(array[i]);
                }
            }
            props.setArray(sortedArray);
        }
        sortedArray = [];
    }

    return (
        <Form id="cover" aria-label="Search Bar" onSubmit={handleSubmit}>
            <Form.Group className="search-bar">
                    <Form.Control
                    aria-label="Search Bar"
                    className="form-input"
                    type="text"
                    placeholder="Type a workout ... "
                    value={queryText}
                    onChange={handleChange}
                    >
                    </Form.Control>
                <Button aria-label="Submit" type="submit"><span className="material-icons">search</span></Button>
            </Form.Group>
        </Form>
    );

}
export default SearchBar;
